import ChangePasswordScreen from 'features/myVaro/screens/PersonalDetails/ChangePassword/ChangePasswordScreen';
import React from 'react';

export default function ChangePassword() {
  return <ChangePasswordScreen />;
}
